<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Follow-up day' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row">

      <div class="col-sm-8 col-12">

        <h5>{{'Information' | translate}}</h5>

        <div class="general-info">

          <div class="form-group">
            <label>{{'Status' | translate}}</label>
            <select class="form-control" [(ngModel)]="entity.status">
              <option *ngFor="let status of statusOptions" [value]="status.value">{{status.name | translate}}</option>
            </select>
          </div>

          <div class="form-group">
            <label>{{'Title' | translate}}</label>
            <input type="text" class="form-control" [(ngModel)]="entity.title" />
          </div>

          <div class="form-group">
            <label>{{'Description' | translate}}</label>
            <ckeditor [editor]="Editor" [className]="'experienceday_description editor_lg'" [config]="editorConfig" [(ngModel)]="entity.description"></ckeditor>
          </div>

          <div class="form-group">
            <label>{{'Minimum amount of students' | translate}}</label>
            <input type="number" class="form-control" [(ngModel)]="entity.minStudents" />
          </div>

          <div class="form-group">
            <label>{{'Maximum amount of students' | translate}}</label>
            <input type="number" class="form-control" [(ngModel)]="entity.maxStudents" />
          </div>

        </div>

      </div>

      <div class="col-sm-4 col-12">

        <div class="possible-dates">

          <h5>{{'Possible dates' | translate}}</h5>

          <div class="form-group">
            <label>{{'Add date' | translate}}</label>
            <div class="input-group">
              <input type="text" (click)="datePicker.toggle()" (dateSelect)="addDate()" class="form-control" [(ngModel)]="date" ngbDatepicker #datePicker="ngbDatepicker" />
              <div class="input-group-append">
                <button class="btn btn-secondary" (click)="datePicker.toggle()">
                  <fa-icon [icon]="faCalendar"></fa-icon>
                </button>
                <button class="btn btn-primary" (click)="addDate()">
                  <fa-icon [icon]="faPlus"></fa-icon>
                </button>
              </div>
            </div>

          </div>

          <div class="alert alert-info" *ngIf="entity.possibleDates.length == 0">
            <span>{{'No results' | translate}}</span>
          </div>

          <table class="table table-striped" *ngIf="entity.possibleDates.length > 0">
            <tbody>
            <tr *ngFor="let date of entity.possibleDates">
              <td>
                {{date | date:'d-MM-YYYY'}}
              </td>
              <td class="text-right">
                <button class="btn btn-outline-danger" (click)="deleteDate(date)">
                  <fa-icon [icon]="faTrash"></fa-icon> {{'Delete' | translate}}
                </button>
              </td>
            </tr>
            </tbody>

          </table>

        </div>

      </div>

    </div>





  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Close' | translate}}</button>
      <button type="button" class="btn btn-primary ml-auto mr-0" (click)="Save()">
        <fa-icon [icon]="faSave"></fa-icon> {{'Save' | translate}}
      </button>
    </div>
  </div>
</div>
